<script>
    import IacSpot from "./IacSpot.svelte";
    import { expandAll } from "./../Stores";
    import { getSpotsString } from "./../Utils.js";

    export let spots;
    let n_spots = spots.n_spots;

    let isEmpty = spots.institutions.length === 0;
    let isExpanded = true;

    function toggleExpand() {
        isExpanded = !isExpanded;
    }
    $: {
        isExpanded = $expandAll;
    }
</script>

<div class="mb-1">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <h4
        class="font-bold italic md:text-lg text-sm mt-1 hover:font-extrabold cursor-pointer"
        on:click={toggleExpand}
    >
        {spots.year}
        <span class=" md:text-sm text-xs font-normal not-italic">
            ({n_spots}
            {getSpotsString(n_spots)})
        </span>
    </h4>
    {#if isExpanded}
        {#if isEmpty}
            <p>Sem vagas</p>
        {:else}
            {#each spots.institutions as institutionObject}
                <IacSpot institution={institutionObject} />
            {/each}
        {/if}
    {/if}
</div>
